import React, { useCallback } from "react";
import { preferredLocationSelector } from "tsi-common-react/src/apps/common/selectors";
import {
    useAppSelector,
    useDispatchers,
} from "tsi-common-react/src/apps/reducers";
import { IStoreSearchFilters } from "tsi-common-react/src/apps/retail/models.interfaces";
import {
    filteredStoreSelector,
    storeSelector,
} from "tsi-common-react/src/apps/retail/selectors";

import { LocatorFilters as LocatorFiltersComponent } from "../components/LocatorFilters";
import { Dispatchers } from "../dispatchers";

export const LocatorFilters = (): React.ReactNode => {
    const filterValues = useAppSelector((state) => state.retail.storeFilters);
    const currentLocation = useAppSelector(preferredLocationSelector);
    const allStores = useAppSelector(storeSelector);
    const filteredStores = useAppSelector(filteredStoreSelector);
    const dispatchers = useDispatchers(Dispatchers);

    const onChange = useCallback(
        (filters: Partial<IStoreSearchFilters>) => {
            dispatchers.updateStoreFilters(filters);
        },
        [dispatchers],
    );

    return (
        <LocatorFiltersComponent
            filterValues={filterValues}
            currentLocation={currentLocation}
            allStores={allStores}
            filteredStores={filteredStores}
            onChange={onChange}
        />
    );
};
